export const projects = [

    {
      title: "Prove your idea (AI)",
      subtitle: "Test it",
      description:
        "It is proof of concept of a platform where you can test your business ideas via a trained artificial intelligence model. You can keep track of your ideas and analyze them. Username: tester1@gmail.com, password: Test1!",
      image: "https://i.ibb.co/h6cbPKz/Screenshot-2025-04-09-115605.png",
      link: "https://proveyouridea.onrender.com/",
    },
    {
      title: "Centro Zeta",
      subtitle: "civil protection",
      description:
        "A website with three blog sections for a civil protection association, where they talk about their mission, publish documents, posts and photos regarding their interventions. ",
      image: "https://i.ibb.co/dM2VdMN/centrozeta.png",
      link: "https://centrozeta.it",
    },
    {
      title: "Proximity",
      subtitle: "app to simplify your work",
      description:
        "It's a very simple application created with Google Appsheet, which allowed you to scan different products. It cross-referenced two lists of data, to let you know which products you should analyze.",
      image: "https://i.ibb.co/f0GMp3z/Ls-Organization-5.png",
      link: "",
    },
    {
      title: "Ls Organization",
      subtitle: "management application",
      description:
        "A no code management application, which aims to manage and organize a team of employees. With this application you can also send and receive reports, so you can see and manage the completed activity.",
      image: "https://i.ibb.co/mFBg47p/Ls-Organization.jpg",
      link: "",
    },
    
  ];